import { render, staticRenderFns } from "./LocalEnvCount.vue?vue&type=template&id=24682895&"
import script from "./LocalEnvCount.vue?vue&type=script&lang=js&"
export * from "./LocalEnvCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports